/**
 * Schemas Zod para tipos temporais branded.
 */
import { z } from 'zod';
import type { DurationMs, IsoDateString, Timestamp } from '../types/temporal.js';

/** Timestamp Unix em ms — inteiro não-negativo. */
export const timestampSchema = z
  .number()
  .int()
  .nonnegative()
  .transform((v) => v as Timestamp);

/** ISO 8601 com timezone (`'2026-05-08T20:30:00.000Z'`). */
export const isoDateStringSchema = z
  .string()
  .datetime({ offset: true })
  .transform((v) => v as IsoDateString);

/** Duração em ms — inteiro não-negativo. */
export const durationMsSchema = z
  .number()
  .int()
  .nonnegative()
  .transform((v) => v as DurationMs);
